import { createContext } from 'react';

export const Context = createContext('Default Value');